import React from 'react'
import '../css/Skills.css'

const Projects = () => {

    const myQualifications = [
        {
            "id": 1,
            "exam": "SSC",
            "uni_clg_scl": "Bhadrason G C Academy",
            "year": "2016",
            "grade": "A"
        },
        {
            "id": 2,
            "exam": "HSC",
            "uni_clg_scl": "Nurul Amin Degree College",
            "year": "2017-2018",
            "grade": "A-"
        },
        {
            "id": 3,
            "exam": "BSc in CSE",
            "uni_clg_scl": "Ranada Prasad Shaha University",
            "year": "2019-2022",
            "grade": "A"
        }
    ]


    return (
        <div className="skillsContainer" id="qualifications">
           <div className="skillsHeader">
               <div className="skillsHeaderText">Qualifications</div>
           </div>
           <div className="qualificationsContainer">
                <ul className="qualificationsList">
                    <li className="qId" key={myQualifications[0].id} >
                        <div className="exam">
                            <b>Exam : </b>{
                            myQualifications[0].exam}
                        </div> 
                        <div className="uni_clg_scl">
                            <b>University/College/School : </b>{
                            myQualifications[0].uni_clg_scl}
                        </div> 
                        <div className="year">
                            <b>Year : </b>
                            {myQualifications[0].year}
                        </div> 
                        <div className="grade">
                            <b>Grade : </b>
                            {myQualifications[0].grade}
                        </div> 
                    </li>

                    <li className="qId" key={myQualifications[1].id} >
                        <div className="exam">
                            <b>Exam : </b>
                            {myQualifications[1].exam}
                        </div> 
                        <div className="uni_clg_scl">
                            <b>University/College/School : </b>
                            {myQualifications[1].uni_clg_scl}
                        </div> 
                        <div className="year">
                            <b>Year : </b>
                            {myQualifications[1].year}
                        </div> 
                        <div className="grade">
                            <b>Grade : </b>
                            {myQualifications[1].grade}
                        </div> 
                    </li>
 
                    <li className="qId" key={myQualifications[2].id} >
                        <div className="exam">
                            <b>Exam : </b>
                            {myQualifications[2].exam}
                        </div> 
                        <div className="uni_clg_scl">
                            <b>University/College/School : </b>
                            {myQualifications[2].uni_clg_scl}
                        </div> 
                        <div className="year">
                            <b>Year : </b>
                            {myQualifications[2].year}
                        </div> 
                        <div className="grade">
                            <b>Grade : </b>
                            {myQualifications[2].grade}
                        </div> 
                    </li>
                </ul>                               
            </div>
        </div>
    )
}

export default Projects